import { useMemo, useState } from 'react';
import { TEAM } from '../config/site';
import { useLocale } from '../context/LocaleContext';
import DepthCarousel from '../components/reactbits/DepthCarousel/DepthCarousel';
import { FinalCTA } from '../components/shared/PageSections';
import { Eyebrow, SectionIntro } from '../components/ui/Primitives';

function AboutHero({ content }) {
  return (
    <section className="about-hero" aria-labelledby="about-title">
      <div className="about-hero__ring" aria-hidden="true" />
      <h1 id="about-title">{content.title}</h1>
      <p>{content.subtitle}</p>
    </section>
  );
}

function FounderStory({ content, role }) {
  return (
    <section className="founder-story section-shell">
      <div className="founder-story__media" data-reveal="image">
        <img src={TEAM[0].src} alt="Devin Baucamp" />
        <span className="founder-story__tag">YourApplicant · Zürich</span>
      </div>
      <div className="founder-story__copy" data-reveal="clip">
        <Eyebrow>YourApplicant</Eyebrow>
        <h2>{content.title}</h2>
        <p>{content.description}</p>
        <div className="founder-signature"><strong>Devin Baucamp</strong><span>{role}</span></div>
      </div>
    </section>
  );
}

function TeamCarousel({ content }) {
  const [active, setActive] = useState(0);
  const items = useMemo(() => TEAM.map((member) => ({ image: member.src, alt: member.name })), []);
  const member = content.members[active];
  const preservePageScroll = (event) => {
    if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) event.stopPropagation();
  };

  return (
    <section className="team-carousel-section section-shell">
      <SectionIntro eyebrow={content.eyebrow} title={content.title} align="center" />
      <div className="team-carousel-layout">
        <div className="team-carousel-meta" aria-live="polite">
          <span>{String(active + 1).padStart(2, '0')} / {String(items.length).padStart(2, '0')}</span>
          <h3>{member.name}</h3>
          <p>{member.role}</p>
        </div>
        <div className="team-carousel-stage" onWheelCapture={preservePageScroll}>
          <DepthCarousel
            items={items}
            cardWidth={310}
            cardHeight={420}
            radius={26}
            tint="#2a303a"
            depth={180}
            spread={82}
            tilt={18}
            tiltDirection="right"
            perspective={1500}
            visibleCards={4}
            falloff={0.16}
            blur={4}
            duration={620}
            ease="power3.out"
            loop
            showControls
            showIndicators
            onChange={(index) => setActive(index)}
          />
        </div>
      </div>
    </section>
  );
}

export default function AboutPage() {
  const { t } = useLocale();
  return (
    <main id="main-content">
      <AboutHero content={t.about.hero} />
      <FounderStory content={t.about.story} role={t.about.team.members[0].role} />
      <TeamCarousel content={t.about.team} />
      <FinalCTA eyebrow={t.home.closing.eyebrow} title={t.home.closing.title} text={t.home.closing.description} buttonLabel={t.home.closing.cta} />
    </main>
  );
}
